import { HostBinding, Component, OnInit } from '@angular/core';

import { routerTransition } from 'app/shared/animations/router-transition.animation';
import { DocumentosService } from 'app/shared/documentos/documentos.service';

import { AgrupadorDocumentos } from 'models/documento';

@Component({
  selector: 'app-editais-manuais',
  templateUrl: './editais-manuais.component.html',
  styleUrls: ['./editais-manuais.component.scss'],
  animations: [routerTransition],
})
export class EditaisManuaisComponent implements OnInit {
  @HostBinding('@routerTransition') routerTransition = true;
  @HostBinding('style.display') display = 'block';

  gruposDoc: AgrupadorDocumentos[] = [];
  documentosCarregando = true;

  constructor(
    private documentosService: DocumentosService,
  ) { }

  ngOnInit() {
    this.documentosService.queryManuaisEditais()
      .then((data: AgrupadorDocumentos[]) => {
        this.gruposDoc = data;

        this.documentosCarregando = false;
      });
  }

  translateCharCode(str) {
    const div = document.createElement('div');
    div.innerHTML = str;
    return div.innerHTML;
  }
}
